import clsx from 'clsx';
import React from 'react';

import imgMediaKit from 'images/pro/MediaKit.svg';
import imgNTRS from 'images/pro/NTRS.png';
import imgNYTLogo from 'images/pro/New-York-Times-logo.png';
import imgAtBayLogo from 'images/pro/at-bay-logo.png';
import imgEdbLogo from 'images/pro/edb-logo.png';

import {
  CORPORATE_SUBSCRIPTION_FORM_URL,
  MEDIA_KIT_URL,
  PARTNERSHIP_FORM_URL,
} from '../../utils/constants';

const ProOpportunities = () => (
  <div className="tw-px-16 xs:tw-px-48 tw-py-48 md:tw-py-64">
    <div className="tw-max-w-[650px] md:tw-max-w-[1024px] tw-px-16 tw-py-24 md:tw-p-48 tw-rounded-10 tw-shadow-pro tw-mx-auto">
      <div className="md:tw-flex tw-justify-center tw-relative">
        <div
          className={clsx(
            'tw-flex tw-flex-col tw-justify-center tw-border-0 tw-border-solid tw-border-stone-300 tw-mx-auto',
            'md:tw-max-w-[575px] md:tw-border-l md:tw-order-1 md:tw-pl-48 md:tw-mx-0'
          )}
        >
          <p className="tw-font-sans tw-text-overline tw-text-primary-red tw-uppercase tw-m-0">
            New
          </p>
          <h3 className="tw-font-serif tw-text-headline-sm md:tw-text-headline-lg tw-text-primary-black tw-m-0 tw-mt-16">
            Brand Partnerships
          </h3>
          <p className="tw-text-paragraph tw-font-serif tw-text-black tw-m-0 tw-mt-16">
            The Information has a highly engaged and influential subscriber base of startup
            founders, venture capitalists, and technology decision makers. We offer numerous
            opportunities for brands to share their message with our subscribers.
          </p>
          <div className="tw-absolute tw-bottom-0 md:tw-static tw-flex tw-flex-col md:tw-flex-row tw-gap-x-12 tw-gap-y-24 md:tw-mt-16 tw-w-full">
            <a
              href={`${PARTNERSHIP_FORM_URL}?source=pro_landing_page`}
              className={clsx(
                'tw-text-button-md tw-font-sans !tw-text-white tw-bg-primary-red uppercase',
                'md:tw-w-[245px] tw-h-40 tw-flex tw-items-center tw-justify-center tw-rounded-r-2',
                'hover:tw-bg-pro-red focus:tw-bg-pro-red tw-transition-colors'
              )}
            >
              Learn More
            </a>
            <a
              href={MEDIA_KIT_URL}
              className={clsx(
                'tw-text-button-md tw-font-sans tw-text-primary-black uppercase',
                'md:tw-w-[245px] tw-h-40 tw-flex tw-items-center tw-justify-center tw-gap-x-12 tw-rounded-r-2',
                'hover:tw-text-gray-600 focus:tw-text-gray-600 tw-transition-colors'
              )}
            >
              <img src={imgMediaKit} alt="" />
              View media kit
            </a>
          </div>
        </div>
        <div className="tw-flex md:tw-flex-col tw-justify-center tw-items-center tw-gap-x-48 tw-gap-y-80 tw-shrink-0 tw-w-full md:tw-w-[248px] tw-mx-auto tw-mt-16 tw-pb-[136px] md:tw-m-0 md:tw-py-36 md:tw-pr-48">
          <div className="tw-w-80 tw-h-[30px] md:tw-w-[150px] md:tw-h-[60px]">
            <img
              className="tw-block tw-object-contain tw-object-center tw-w-full tw-h-full"
              src={imgEdbLogo}
              alt="EDB Singapore"
            />
          </div>
          <div className="tw-w-80 tw-h-[30px] md:tw-w-[150px] md:tw-h-[60px]">
            <img
              className="tw-block tw-object-contain tw-object-center tw-w-full tw-h-full"
              src={imgAtBayLogo}
              alt="At Bay"
            />
          </div>
          <div className="tw-w-80 tw-h-[30px] md:tw-w-[150px] md:tw-h-[60px]">
            <img
              className="tw-block tw-object-contain tw-object-center tw-w-full tw-h-full"
              src={imgNTRS}
              alt="Northern Trust"
            />
          </div>
        </div>
      </div>
    </div>
    <div className="tw-max-w-[650px] md:tw-max-w-[1024px] tw-px-16 tw-py-24 md:tw-p-48 tw-rounded-10 tw-shadow-pro tw-mt-32 md:tw-mt-48 tw-mx-auto">
      <div className="md:tw-flex tw-justify-center tw-relative">
        <div
          className={clsx(
            'tw-flex tw-flex-col tw-justify-center tw-border-0 tw-border-b tw-border-solid tw-border-stone-300 tw-mx-auto tw-pb-16',
            'md:tw-max-w-[575px] md:tw-border-l md:tw-border-b-0 md:tw-order-1 md:tw-pl-48 md:tw-pb-0 md:tw-mx-0'
          )}
        >
          <p className="tw-font-sans tw-text-overline tw-text-primary-red tw-uppercase tw-m-0">
            More opportunities
          </p>
          <h3 className="tw-font-serif tw-text-headline-sm md:tw-text-headline-lg tw-text-primary-black tw-m-0 tw-mt-16">
            Corporate Subscriptions
          </h3>
          <p className="tw-text-paragraph tw-font-serif tw-text-black tw-m-0 tw-mt-16">
            Empower your team with deep industry knowledge and networking opportunities with other
            subscribers. The Information corporate subscription packages are available for teams of
            all sizes.
          </p>
          <a
            href={`${CORPORATE_SUBSCRIPTION_FORM_URL}?source=pro_landing_page`}
            className={clsx(
              'tw-absolute tw-bottom-0 md:tw-static tw-text-button-md tw-font-sans !tw-text-white tw-bg-primary-red uppercase',
              'md:tw-w-[245px] tw-h-40 tw-flex tw-items-center tw-justify-center tw-rounded-r-2 md:tw-mt-16 tw-w-full',
              'hover:tw-bg-pro-red focus:tw-bg-pro-red tw-transition-colors'
            )}
          >
            Learn More
          </a>
        </div>
        <div className="tw-flex tw-flex-col tw-justify-center tw-shrink-0 tw-w-full md:tw-w-[248px] tw-mx-auto tw-pb-72 md:tw-m-0 md:tw-py-36 md:tw-pr-48">
          <p className="tw-font-sans tw-text-paragraph tw-text-primary-black tw-m-0 tw-mt-16 tw-ml-24 md:tw-mx-0">
            <span className="absolute tw-font-sans tw-font-medium tw-text-[42px] md:tw-text-[72px] tw-text-pro-red tw-left-0 tw-translate-y-[10px] md:tw-left-auto md:-tw-translate-y-[16px]">
              “
            </span>
            The Information{'’'}s reporters have become{' '}
            <span className="tw-font-sans tw-font-bold">
              known in Silicon Valley for sniffing out the industry{'’'}s misdeeds and tweaking its
              powerful.”
            </span>
          </p>
          <div className="tw-w-[172px] tw-mt-16 tw-ml-24 md:tw-mt-32 md:tw-mx-0">
            <img
              className="tw-block tw-object-contain tw-w-full"
              src={imgNYTLogo}
              alt="The New York Times"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ProOpportunities;
